import React from "react";

import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { Alert, AlertTitle } from "@material-ui/lab";
import FormControl from "@material-ui/core/FormControl";

import TextField from "../../components/CstmTextField";
import SelectField from "../../components/SelectField";
import ScreenWrapper from "../../components/ScreenWrapper";
import MobileTextField from "../../components/MobileTextField";
import MultiSelectField from "../../components/MultiSelectField";

import { checkEmail } from "../../actions/checkEmail.actions";

import yes_no from "../../constants/yes_no";
import { PAGES } from "../../config/constants";
import state_dom from "../../constants/state_dom";
import bridge_financing_per_yr from "../../constants/bridge_financing_per_yr_list";
import volume_of_closed_bsnss_per_yr_list from "../../constants/volume_of_closed_bsnss_per_yr_list";

import validate from "./validations";

const BrokerQuestion = ({
  setPrevPage,
  submitForm,
  contacts,
  showError,
  showLogin,
}) => {
  const initialValues = {
    first_name: contacts.first_name || "",
    last_name: contacts.last_name || "",
    phone_mobile: contacts.phone_mobile || "",
    email: contacts.email || "",
    area_you_service: contacts.area_you_service || [],
    appropriate_licensing: contacts.appropriate_licensing || "",
    bridge_financing_per_month: contacts.bridge_financing_per_month || "",
    bridge_financing_per_yr: contacts.bridge_financing_per_yr || "",
  };

  return (
    <ScreenWrapper step={3}>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          submitForm(values);
        }}
        validate={validate}
      >
        {({ handleSubmit }) => (
          <React.Fragment>
            {showError === true && (
              <React.Fragment>
                <Alert severity="error">
                  <AlertTitle>Attention</AlertTitle>
                  User already have a password. Please login
                </Alert>
                <br />
              </React.Fragment>
            )}

            <Field
              name="first_name"
              label="First Name of Referral Partner"
              component={TextField}
              required
            />

            <Field
              name="last_name"
              label="Last Name of Referral Partner"
              component={TextField}
              required
              style={{ marginTop: 10 }}
            />

            <FormControl
              variant="outlined"
              style={{ marginTop: 15, width: "100%" }}
              id="mobile_formControl"
            >
              <Field
                name="phone_mobile"
                label="Mobile of Referral Partner *"
                component={MobileTextField}
                required
              />
            </FormControl>

            <Field
              name="email"
              label="Email of Referral Partner"
              component={TextField}
              required
              style={{ marginTop: 10 }}
            />

            <Field
              name="area_you_service"
              component={MultiSelectField}
              options={state_dom}
              label="In which state do you primarily broker bridge loans in? *"
            />

            <Field
              name="appropriate_licensing"
              component={SelectField}
              options={yes_no}
              label="Do you have appropriate licensing ? *"
              formControlStyle={{ style: { marginTop: 10 } }}
            />

            <Field
              name="bridge_financing_per_yr"
              component={SelectField}
              options={bridge_financing_per_yr}
              label="How many bridge loans did u broker last year? *"
              formControlStyle={{ style: { marginTop: 10 } }}
            />

            <Field
              name="bridge_financing_per_month"
              component={SelectField}
              options={volume_of_closed_bsnss_per_yr_list}
              label="Bridge Loan Volume on a monthly basis? *"
              formControlStyle={{ style: { marginTop: 10 } }}
            />

            <div style={{ marginTop: 10 }}>
              <div style={{ float: "left" }}>
                <button
                  type="button"
                  className="cstm_btn cstm_btn-blue"
                  onClick={showLogin}
                >
                  Login
                </button>
              </div>
              <div style={{ float: "right" }}>
                <button
                  type="button"
                  className="cstm_btn cstm_btn-text"
                  onClick={setPrevPage}
                >
                  Back
                </button>

                <button
                  type="button"
                  className="cstm_btn cstm_btn-blue"
                  onClick={handleSubmit}
                >
                  Next
                </button>
              </div>
            </div>
          </React.Fragment>
        )}
      </Formik>
    </ScreenWrapper>
  );
};

const mapState = (state) => {
  return {
    contacts: state.form.contacts,
    showError: state.form.showError,
  };
};

const mapDispatch = (dispatch) => {
  return {
    setPrevPage: () => {
      dispatch({
        type: "SET_PAGE",
        payload: 2,
      });
    },
    setContactForm: (values) => {
      dispatch({
        type: "SET_FORM_CONTACTS",
        payload: values,
      });
    },
    setLoading: () => {
      dispatch({
        type: "SET_LOADING",
        payload: true,
      });
    },
    submitForm: (values) => {
      dispatch(checkEmail(values));
    },
    showLogin: () => {
      dispatch({
        type: "SET_FORM_ERROR",
        payload: false,
      });

      dispatch({
        type: "SET_PAGE",
        payload: PAGES.LOGIN,
      });
    },
  };
};

export default connect(mapState, mapDispatch)(BrokerQuestion);



// WEBPACK FOOTER //
// ./src/Screens/BrokerQuestion/index.js